import React, { useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { Collapse, List, ListItem, ListItemIcon, ListItemText, Popover } from '@material-ui/core';
import burgerIcon from '../../assets/images/burger.svg';
import LogoutIcon from '../../assets/images/menu-icons/log-out.svg?react';
import TenantIcon from '../../assets/images/menu-icons/tenant.svg?react';
import ExpandLess from '../../assets/images/expand-less.svg?react';
import ExpandMore from '../../assets/images/expand-more.svg?react';
import CsvItems from './list-parts/CsvItems';
import ExportDialog from '../ExportDialog';

export const isDev =
  window.location.hostname.includes('localhost') ||
  window.location.hostname.includes('dev-cv-builder');

const LogoutBurger = ({ handleLogout, userTenants, templates, sendData, spinner }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isOpenExport, setIsOpenExport] = useState(false);
  const [chosenTemplate, setChosenTemplate] = useState('');
  const [isExportDialogOpen, setIsExportDialogOpen] = useState(false);

  const handleMainClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSwitchTenant = () => {
    window.location.href = `${import.meta.env.REACT_APP_AUTH_MODULE}#/switch?redirect=${
      import.meta.env.REACT_APP_REDIRECT_URL
    }`;
  };

  const handleClickExport = () => setIsOpenExport(!isOpenExport);

  const handleTemplateClick = (event, template) => {
    event.stopPropagation();
    setChosenTemplate(template.name);
    setIsExportDialogOpen(true);
    setTimeout(handleClose, 0);
  };

  return (
    <>
      <Tooltip title="Open menu">
        <div
          onClick={handleMainClick}
          className="w-10 h-10 ml-1 rounded-full hover:bg-gray-200 cursor-pointer flex items-center justify-center"
        >
          <img src={burgerIcon} className="w-6" alt="burger" />
        </div>
      </Tooltip>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{ bgcolor: 'background.paper' }}
      >
        <List component="nav" style={{ width: '208px' }}>
          {/* <PdfItems spinner={spinner} handleClose={handleClose} /> */}
          {/* <GoogleDocItems templates={templates} sendData={sendData} handleClose={handleClose} /> */}
          {isDev && <CsvItems handleClose={handleClose} />}
          {/* {(isSale || isAdmin) &&
            !isTeamManager &&
            import.meta.env.REACT_APP_AUTHORIZE_ENV !== 'prod' && (
              <ListItem
                button
                style={{ gap: '8px', padding: '4px 10px' }}
                onClick={handleAdminClick}
              >
                <ListItemIcon style={{ minWidth: 0 }}>
                  <AdminIcon />
                </ListItemIcon>
                <ListItemText primary="Viewing history" />
              </ListItem>
            )} */}
          {/* 
          {(isSale || isAdmin) &&
            !isTeamManager &&
            import.meta.env.REACT_APP_AUTHORIZE_ENV !== 'prod' && (
              <ListItem
                button
                style={{ gap: '8px', padding: '4px 10px' }}
                onClick={handleLinkClick}
              >
                <ListItemIcon style={{ minWidth: 0 }}>
                  <LinkIcon />
                </ListItemIcon>
                <ListItemText primary="Temporary links" />
              </ListItem>
            )} */}
          {/* <CsvItems handleClose={handleClose} /> */}

          <ListItem
            button
            style={{
              gap: '8px',
              padding: '4px 10px',
              borderBottom: !isOpenExport && '1px solid #EDF2F7',
            }}
            onClick={handleClickExport}
          >
            <ListItemText primary="Export as..." />
            {isOpenExport ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse
            in={isOpenExport}
            timeout="auto"
            unmountOnExit
            style={{ borderBottom: isOpenExport && '1px solid #EDF2F7' }}
          >
            <List component="div" disablePadding>
              {[...templates, { _id: 'hays', name: 'Hays' }].map(
                ({ _id: templateId, name, ...templateRest }) => {
                  const template = { _id: templateId, name, ...templateRest };
                  return (
                    <ListItem
                      key={templateId}
                      button
                      style={{ paddingTop: 4, paddingBottom: 4, paddingLeft: 12 }}
                      onClick={(e) => handleTemplateClick(e, template)}
                    >
                      <ListItemText style={{ textTransform: 'capitalize' }} primary={name} />
                    </ListItem>
                  );
                },
              )}
            </List>
          </Collapse>

          {userTenants.length > 1 && (
            <ListItem
              button
              style={{ gap: '8px', padding: '4px 10px' }}
              onClick={handleSwitchTenant}
            >
              <ListItemIcon style={{ minWidth: 0 }}>
                <TenantIcon style={{ width: '20px', height: '20px' }} />
              </ListItemIcon>
              <ListItemText primary="Switch Company" />
            </ListItem>
          )}

          <ListItem button style={{ gap: '8px', padding: '4px 10px' }} onClick={handleLogout}>
            <ListItemIcon style={{ minWidth: 0 }}>
              <LogoutIcon style={{ width: '20px', height: '20px' }} />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItem>
        </List>
      </Popover>
      <ExportDialog
        templates={[...templates, { _id: 'hays', name: 'Hays' }]}
        choseTemplate={chosenTemplate}
        open={isExportDialogOpen}
        onClose={() => {
          setIsExportDialogOpen(false);
          setChosenTemplate('');
        }}
        sendData={sendData}
        spinner={spinner}
      />
    </>
  );
};

export default LogoutBurger;
